/**
 * Shared Auth Context
 *
 * Extracted to avoid circular dependencies between LazyAuthProvider and AuthProvider.
 * Both providers use this same context so consumers (useAuthContext) work regardless
 * of which provider is active.
 */

import { createContext } from 'react';
import type { AuthContextValue } from './types';

export const AuthContext = createContext<AuthContextValue | null>(null);
